/* eslint-disable */
<template>
  <div class="table-toolbar">

    <v-card class="mobile-height" elevation="0">
      <v-card-title class="main-toolbar">

          <!--action buttons-->
          <div class="actions">
            <div class="padding-right" v-if="activeViewLearners ==='Classes'">
              <v-btn
                @click="(instructorData.migrated || learnerData.migrated) ? null : handleDialogOpen({type:'joinClass', data: {}})"
                text 
                :disabled="learnersAjaxing || !!instructorData.migrated || !!learnerData.migrated"
                class="branded-background text-white tabable"
                aria-label="Join new class button. Press enter to open the join class modal."
              >
                {{addNew}}
              </v-btn>
            </div>

            <div  class="padding-right" v-if=" activeViewLearners === 'Classes' || activeViewLearners === 'Bulbs'">
              <v-btn
                @click="(instructorData.migrated || learnerData.migrated) ? null : broadcast()"
                flat
                :disabled="learnersAjaxing || !!instructorData.migrated || !!learnerData.migrated"
                class="branded-text"
              >
                Join Broadcast
              </v-btn>
            </div>
          </div>



          <!--data manipulation buttons-->
          <div class="data-manipulation">
            <div class="search">
              <v-form @submit.prevent="search" class="search-form">
                <v-text-field
                tabindex="0"
                v-model="queryParamsLearners.search"
                label="Search"
                single-line
                hide-details
                append-icon="search"
                @click:append="search"
                @click:clear="clearSearch"
                @paste="search"
                clearable
                :disabled="this.learnersAjaxing || dialogOpen"
                :aria-label="`Search input for table data in ${activeViewLearners}. Type a search string and press enter to display search results in the table.`"
                ></v-text-field>
              </v-form>
            </div>
            
            <div class="center-btn">
              <Tooltip top>
                <v-btn :disabled ="learnersAjaxing || dialogOpen" icon name="refresh" @click="refresh" :aria-label="`Refresh data button. Press enter to refresh the data on the ${activeViewLearners} table.`" class="refresh">
                   <v-icon :tabindex="-1" >refresh</v-icon>
                </v-btn>
                <template v-slot:text>
                  Refresh Data
                </template>
              </Tooltip>
            </div>
          </div>



        </v-card-title>
      </v-card>
  </div>
</template>

<script>
import router from '../../router';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'learner-table-toolbar',
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState('learners', [
      'learnerSectionHasPlaylist',
      'learnerSectionPlaylists',
    ]),
    ...mapGetters([
      'activeView',
      'breadcrumbs',
      'dialogShow',
      'instructorData',
      'phpApiPrefix',
      'popoverToggles',
      'learnerData',
    ]),
    ...mapGetters('learners', [
    'activeViewLearners',
    'learnersAjaxing',
    'queryParamsLearners',
    'learnerDataLoaded',
    'selectedData',
    'classes',
  ]),
    addNew: function(){
      //creates the add new computer variable based on learner active view
      switch(this.activeViewLearners){
        case 'Classes':
          return 'Join New Class'
        default:
          return 'Add New'
      }
    },
    searchWatch: function() {
      //returns search query param
      return this.queryParamsLearners.search;
    },
    dialogOpen: function(){
      return(this.dialogShow.dash)
    },
  },
  methods:{
    ...mapMutations([
      'handleDialogOpen',
    ]),
    search: function(){
      //updates data and url based on search
      this.$store.commit('learners/setQueryParams', {page:1, per_page: 20});
      if(this.activeViewLearners != 'LMB-Monitor'){
        this.$store.dispatch('learners/getTableData')
      } else {
        this.$store.dispatch('learners/getMonitorData');
      }
      this.$store.dispatch('learners/updateUrl');
    },
    clearSearch: function(){
      this.$store.commit('learners/setQueryParams', {search:""});
      this.$store.dispatch('learners/updateUrl');
      if(this.activeViewLearners != 'LMB-Monitor'){
        this.$store.dispatch('learners/getTableData')
      } else {
        this.$store.dispatch('learners/getMonitorData');
      }
    },
    refresh: function(){
      //updates data
      if(this.activeViewLearners != 'LMB-Monitor'){
        this.$store.dispatch('learners/getTableData')
      } else {
        this.$store.dispatch('learners/getMonitorData');
      }
    },
    broadcast: function(){
      window.open(`${this.phpApiPrefix}/broadcast-v3?access_token=${this.$store.state.learnerData.token}`)
    }
  },
  watch: {
    searchWatch: {
      handler: function(val, oldVal){
        //if search is reset, calls data refresh
        if(val === '' && oldVal != ''){
          this.search();
        }
      }
    }
  },
  mounted() {

  },
  updated() {
  }
};
</script>

<style scoped>


</style>


